export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=40ec22f3&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/index.vue?vue&type=template&id=40ec22f3&scoped=true
// module id = saDt
// module chunks = 0